import { Text, Link, isMobileStyleMixin } from '@amzn/storm-ui';
import styled, { css } from 'styled-components';

const DisabledLink = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40026394__sc-do3u3a-0"
})(["cursor:not-allowed;color:", ";"], ({
  theme
}) => theme.text.color.unavailable);
const StyledLink = /*#__PURE__*/styled(Link).withConfig({
  componentId: "sc-storm-ui-40026394__sc-do3u3a-1"
})(["font-size:", ";", ""], ({
  theme
}) => theme.font.text.medium.default, isMobileStyleMixin(css(["font:", ""], ({
  theme
}) => theme.font.text.base.mobile)));

export { DisabledLink as D, StyledLink as S };
//# sourceMappingURL=LinkAttribute.styles-BhNL4JTw.js.map
